import { appendParams } from '@utils/func'
import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

class AppBannerManagementApi implements IAPI {
  prefix = '/AppBannerManagement'

  fetchList (params: TAppBannerManagement.FetchList) {
    const url = appendParams(`${this.prefix}/List`, { ...params })
    return API.get<TAppBannerManagement.TState['bannerList']>(url)
  }

  fetchSingle (id: string) {
    return API.get<TAppBannerManagement.TState['bannerUpsert']>(`${this.prefix}/GetDetail/${id}`)
  }

  async create (data: any) {
    const response = await API.post<TAppBannerManagement.TState['bannerUpsert']>(`${this.prefix}/Create`, data)
    return response.data
  }

  async update (data: any) {
    const response = await API.put<TAppBannerManagement.TState['bannerUpsert']>(`${this.prefix}/Update`, data)
    return response.data
  }
}

export const appBannerManagementApi = new AppBannerManagementApi()
